import React, {useEffect, useState, useCallback} from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';

import styles from './modal.module.css';

import {getTeams} from '../../../../actions/my-topic';
import useDisableScrollDocument from '../../../../useHook/useDisableScrollDocument';
import {detectIconById} from '../../../../common/enum'

function TopicChooseUser(props) {
    useDisableScrollDocument();

    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedTeam, setSelectedTeam] = useState(null);

    const dispatch = useDispatch();

    useEffect(() => {
        fetchMyTeams();
    }, []);

    const fetchMyTeams = useCallback(async () => {
        setLoading(true);
        const response = await dispatch(getTeams());
        setLoading(false);
        setTeams(response);
    } ,[]);

    const onItemSelect = useCallback((item) => {
        setSelectedTeam(item);
        props.onChange(item);
    }, []);

    return <div className={styles.modalWrapper}>
        <div style={{position: 'absolute', height: '100%', width: '100%'}} onClick={props.onClose}/>
        <div className={styles.modalContent}>
            <h4 className={styles.modalTitle}>
                球団を選択
            </h4>
            <div className={styles.teamWrapper}>
                {loading && <div className={styles.topicLoading}>
                    <FontAwesomeIcon icon={faSpinner} pulse color={'#3D3DF2'} size="lg"/>
                </div>
                }
                {teams.map((item, index) => {
                    return <div key={index}
                                style={{display: 'flex', alignItems: 'center'}}
                                className={classNames(styles.teamItem, selectedTeam && selectedTeam.id === item.id && styles.active)}
                                onClick={() => onItemSelect(item)}>
                        <img style={{width: 36, marginRight: 10}} src={detectIconById(item.id)} alt=""/> {item.team_name_s}
                    </div>
                })}
            </div>
        </div>
    </div>
}

export default TopicChooseUser;
